import { BookFilled, BookOutlined } from '@ant-design/icons';
import { Button, Popover, Space, Tooltip } from "antd";
import React, { useEffect } from "react";

import { apiCall } from "../utils/Api";
import { useSession } from "../utils/Session";
import { objectToPath } from "../utils/Utils";

export default function Bookmark(props) {

    const { link = false, results, searchFilters = {}, isbn = "", list_id = "", on_page = false } = props;
    const [session, setSession] = useSession();
    const addBookmark = () => {
        let sf = { ...searchFilters };
        apiCall("titlelist/setBookmark", { list_id: list_id, isbn: isbn, url: objectToPath(sf) }, (_status, _result) => {
            if (_status) {
                setSession({ ...session, "titlelist_bookmarks": _result })
            }
        })
    }

    const removeBookmark = () => {
        apiCall("titlelist/removeBookmark", { list_id: list_id }, (_status, _result) => {
            if (_status) {
                setSession({ ...session, "titlelist_bookmarks": _result })
            }
        })
    }

    const linkOut = (_path, _target = "_blank") => {
        window.open("/browse" + _path + "#bookmark", _target);
    }


    const scrollToMe = () => {
        if (session.titlelist_bookmarks != null && session.titlelist_bookmarks.find(item => item.isbn === isbn)) {
            if (window.location.hash.includes("#bookmark")) {
                setTimeout(() => {
                    scrollToHash("#bookmark")
                }, 100)
            }
        }
    }

    useEffect(scrollToMe, [])

    function anchorExists(hash) {
        if (!hash) return false;
        const anchor = hash.startsWith('#') ? hash.slice(1) : hash;
        let _r = document.getElementById(anchor) !== null;
        return _r;
    }


    const drawLink = () => {
        let _obj = session.titlelist_bookmarks.find(item => item.titlelist_id === list_id);
        if (!_obj) {
            return <div style={{ "width": "22px" }}>&nbsp;</div>;
        }
        return (
            <Popover overlayInnerStyle={{ "padding": "0px" }} placement="bottom" content={
                <Space direction="vertical">
                    <Button block type="primary" onClick={() => linkOut(_obj.url)} size="small"><small>Go to bookmark</small></Button>
                    <Button onClick={() => removeBookmark()} block danger size="small"><small>Remove this bookmark</small></Button>
                </Space>
            }>
                <div style={{ "padding": "0px 5px" }}>
                    <BookFilled style={{ "color": "#ff6633", "cursor": "pointer" }} />
                </div>
            </Popover>
        )
    }

    if (!list_id) {
        return (<></>)
    }

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    if (on_page) {

        let _obj = session.titlelist_bookmarks.find(item => item.titlelist_id === list_id);
        if (!_obj) {
            return <></>;
        }

        return (
            <Tooltip title={<small>Go to bookmarked item in catalogue</small>} >
                <div style={{ "padding": "0px 5px" }}>
                    <BookFilled onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!anchorExists("#bookmark")) {
                            linkOut(_obj.url, "_self")
                        } else {
                            scrollToHash("#bookmark");
                        }

                    }} style={{ "color": "#ff6633", "cursor": "pointer" }} />
                </div>
            </Tooltip>
        )


    }

    if (link) {
        return drawLink();
    }

    return (
        <div onClick={() => {
            if (session.titlelist_bookmarks.find(item => item.isbn === isbn)) {
                removeBookmark();
            } else {
                addBookmark();
            }
        }} style={{ "position": "absolute", "marginLeft": "-66px", "top": "5px", "color": "#aaa", "cursor": "pointer" }}>
            {(session.titlelist_bookmarks.find(item => item.isbn === isbn)) ? <Tooltip title="Remove bookmark"> <div id="bookmark" style={{ "position": "absolute", "top": "-100px" }}></div><BookFilled style={{ "color": "#ff6633", "fontSize": "12px" }} /></Tooltip> : <Tooltip title="Bookmark this title to remember your place in this list."><BookFilled style={{ "color": "#aaa", "fontSize": "12px" }} /></Tooltip>}
        </div>)
}